import { requirePermission } from "@/lib/casl/route-guards";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { DataTable } from "@/components/data-table/data-table";
import { columns } from "@/components/mentor-scoring/detail-columns";
import { useGetMentorshipSnapshotDetails } from "@/lib/api/mentor-scoring";
import { useDataTable } from "@/lib/hooks/use-data-table";
import { useRouter, useSearch } from "@tanstack/react-router";
import { ChevronLeftIcon } from "@radix-ui/react-icons";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authenticated/mentor-scoring/details/$snapshotId")({
  component: SnapshotDetailsPage,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "mentor-scoring");
  },
});

function SnapshotDetailsPage() {
  const router = useRouter();
  const { snapshotId } = useParams({
    strict: false,
  }) as { snapshotId: string };
  const { page, per_page} = useSearch({
      strict: false,
    }) as Record<string, string>;
  
    const currentPage = parseInt(page || "1", 10);
    const pageSize = parseInt(per_page || "20", 10);
    
    
    const { data } = useGetMentorshipSnapshotDetails(
      snapshotId,
      currentPage,
      pageSize,
    );
    
    const { table } = useDataTable({
      columns,
      data: data?.details || [],
      defaultPerPage: pageSize,
      pageCount: -1,
      filterFields: [],
    });
    
    const handlePageChange = (newPageIndex: number) => {
      const newPage = newPageIndex + 1;
      router.navigate({
        to: router.state.location.pathname,
        search: (prev: any) => ({
          ...prev,
          page: newPage,
        }),
      });
    };
  
    const handlePageSizeChange = (newPageSize: number) => {
      router.navigate({
        to: router.state.location.pathname,
        search: (prev: any) => ({
          ...prev,
          page: 1,
          per_page: newPageSize,
        }),
      });
    };

  return (
    <div className="min-h-screen bg-gray-50">
      
      <div className="container mx-auto space-y-6 px-4 py-6">
        <Button
                size="icon"
                variant="ghost"
                onClick={() => {
                  router.history.back();
                }}
              >
                <ChevronLeftIcon className="h-6 w-6" />
        </Button>
        {/* <Header user={user}/> */}
        <DataTable
        table={table}
        getCanNextPage={() => {
          return !data?.isLastPage;
        }}
        getCanPreviousPage={() => {
          return currentPage > 1;
        }}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      >
      </DataTable>
      </div>
    </div>
  );
}
